var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('the-app',{attrs:{"product-variants":_vm.filteredVariants}})
}
var staticRenderFns = []

export { render, staticRenderFns }